import script from "./LoginBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginBtn.vue?vue&type=script&setup=true&lang=ts"

import "./LoginBtn.vue?vue&type=style&index=0&id=5ab85d52&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ab85d52"]])

export default __exports__